import moment from 'moment';
import { WalkThrough } from 'src/SharedCustomHooks/UseSuiteActions/types';

export const ADMIN_LINK_VIEW_ROLES: string[] = [
  'Admin',
  'Super Admin',
  'Property Developer',
  'Strata Manager',
];

export const ACTIVE_WALKTHROUGH_STATUSES: string[] = [
  'Guided Walk Through',
  'Self-Guided Walk Through',
  'In Progress Home Only',
  'In Progress Home',
  'In Progress',
  'Begin',
  'Schedule',
];

export const isHomeOwnerOccupantUser = (someUser: any): boolean =>
  !!(
    someUser?.roles?.length > 0 &&
    ['Home Owner', 'Realtor', 'Occupant'].includes(someUser.roles[0].role.name)
  );

export const isHomeOwnerCheckUser = (someUser: any): boolean =>
  !!(
    someUser?.roles?.length > 0 &&
    ['Home Owner', 'Realtor', 'Occupant', 'Strata Manager'].includes(
      someUser.roles[0].role.name
    )
  );

export const calculateWarrantyDaysRemaining = (
  warrantyDate: string,
  currentMoment: any
): number => {
  const estimatedDaysRemaining: number = moment(warrantyDate).diff(
    currentMoment,
    'days'
  );
  return estimatedDaysRemaining - 1;
};

export const computeActiveTabIndex = (
  location: any,
  walkThroughs: WalkThrough[]
): number => {
  if (location?.state?.activeTab !== undefined) {
    const hasActiveWalkThrough: boolean = walkThroughs.some(
      (walkThroughItem: WalkThrough) => {
        if (walkThroughItem.walkthroughType === 'Home Owner Walk-through') {
          return ACTIVE_WALKTHROUGH_STATUSES.includes(walkThroughItem.status);
        }
        return false;
      }
    );

    return hasActiveWalkThrough && walkThroughs.length > 0
      ? location.state.activeTab + 1
      : location.state.activeTab;
  }

  const currentUrlString: string = window.location.href;
  const urlActiveTab: string = currentUrlString.split('activeTab=')[1];
  return urlActiveTab ? Number(urlActiveTab) : 0;
};

export const shouldShowHomeownerFeedback = (user: any): boolean => {
  const isHomeOwner: boolean =
    user?.roles?.length > 0 && user.roles[0].role.name === 'Home Owner';

  if (!isHomeOwner) {
    return false;
  }

  const isShowHomeownerDashboardPage: boolean = JSON.parse(
    localStorage.getItem('showHomeownerDasboardPage') || 'false'
  );

  if (isShowHomeownerDashboardPage) {
    return false;
  }

  const isFeedbackReportPopup: string | null = localStorage.getItem(
    'IsHomerNavigatFromFeedBackTemplate'
  );

  return !!isFeedbackReportPopup;
};
